import React from 'react'
import styles from './index.module.css'
import { Typography } from '@material-ui/core'
import { useStaticQuery } from 'gatsby'
import get from 'lodash/get'
import FollowAt from './social-media-follow'

export default ({}) => {
  const data = useStaticQuery(graphql`
    query FollowUsQuery {
      allContentfulSocialCondividi {
        edges {
          node {
            id
            name
            link
            icon {
              fluid(maxWidth: 1200, background: "rgb:000000") {
                ...GatsbyContentfulFluid
              }
            }
          }
        }
      }
    }
  `)
  const socialCondividi = get(data, 'allContentfulSocialCondividi.edges')

  return (
    <div className={styles.container}>
      <div className={styles.gridContainer}>
        <Typography variant={'h3'} className={styles.followTitle}>Seguici su</Typography>
        <div className={styles.socialIcons}>
          <FollowAt
            links={socialCondividi.map(({ node: social }) => social.link)}
            iconSize={4}
          />
        </div>
      </div>
    </div>
  )
}
